
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 100"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 2886","transform":"translate(-88 -839)"}},[_c('rect',{attrs:{"data-name":"Rectangle 4630","width":"56.667","height":"80","rx":"7","transform":"translate(131.333 839)","fill":"#999"}}),_c('rect',{attrs:{"data-name":"Rectangle 4628","width":"56.667","height":"80","rx":"7","transform":"translate(111.333 849)","fill":"#218665"}}),_c('rect',{attrs:{"data-name":"Rectangle 4629","width":"56.667","height":"80","rx":"7","transform":"translate(88 859)","fill":"#0fa"}})])])
          )
        }
      }
    